/**
 * Friendly es-PA label for an audit action code (e.g. `expediente.updated` →
 * "Expediente actualizado"), via the shared `esPA.auditoria.actions` catalog.
 * Falls back to the raw code for actions this build doesn't recognize (a
 * demo-only seed action, or a server ahead of this bundle) — never throws on
 * an unmapped key.
 *
 * Kept in its own tiny module with no `lib/api`/`lib/hooks` imports so both
 * `lib/demo.ts` (which `lib/api.ts` imports) and consumers of `lib/hooks.ts`/
 * `lib/api.ts` can use it without risking a circular import.
 */
import { esPA } from '@cumpli/shared';

const ACTION_LABELS: Record<string, string> = esPA.auditoria.actions;

export function auditActionLabel(action: string): string {
  return ACTION_LABELS[action] ?? action;
}

/**
 * Friendly es-PA category label for an `ExpedienteActivityEntry.entityType`
 * (e.g. `expediente_document` → "Documento"), via the shared
 * `esPA.expedienteActivity.categories` catalog. Same unmapped-key fallback
 * guarantee as `auditActionLabel`.
 */
const CATEGORY_LABELS: Record<string, string> = esPA.expedienteActivity.categories;

export function activityCategoryLabel(entityType: string): string {
  return CATEGORY_LABELS[entityType] ?? entityType;
}
